import EmployeeDetails from './EmployeeDetails'

export default EmployeeDetails
